export class CivilSearchConstants {

    public static PAGE_SIZE = 50;

    public static case_types = [
        { id: 'CVD', name: 'CIVIL DISTRICT' },
        { id: 'CVM', name: 'CIVIL MAGISTRATE' },
        { id: 'CVS', name: 'CIVIL SUPERIOR' },
        { id: 'CR', name: 'CRIMINAL DISTRICT' },
        { id: 'CRS', name: 'CRIMINAL SUPERIOR' },
        { id: 'E', name: 'ESTATE' },
        { id: 'EO', name: 'ESTATE OTHER' },
        { id: 'J', name: 'JUVENILE' },
        { id: 'M', name: 'MISCELLANEOUS' },
        { id: 'R', name: 'REGISTRATION' },
        { id: 'SP', name: 'SPECIAL PROCEEDING' }
      ];

      public static case_types_for_civil_actions = [
        { id: 'CVD', name: 'CIVIL DISTRICT' },
        { id: 'CVM', name: 'CIVIL MAGISTRATE' },
        { id: 'CVS', name: 'CIVIL SUPERIOR' },
        { id: 'CR', name: 'CRIMINAL DISTRICT' },
        { id: 'CRS', name: 'CRIMINAL SUPERIOR' },
        { id: 'J', name: 'JUVENILE' }
      ];

      public static case_types_for_estates = [
        { id: 'E', name: 'ESTATE' },
        { id: 'EO', name: 'ESTATE OTHER' }
      ];

      public static case_types_for_special_proceedings = [
        { id: 'SP', name: 'SPECIAL PROCEEDING' }
      ];

      public static case_types_for_registrations = [
        { id: 'R', name: 'REGISTRATION' }
      ];

      public static case_types_for_miscellaneous = [
        { id: 'M', name: 'MISCELLANEOUS' }
      ];


      public static issue_types = [
        { id: 'ADDP', name: 'ADD ADDITIONAL PARTY' },
        // { id: 'AADP', name: 'ADD ADDITIONAL PARTY' }, removed for CQ 36101
        { id: 'ADMA', name: 'ADMINISTRATIVE APPEAL' },
        { id: 'ADOP', name: 'ADOPTION' },
        { id: 'AFCP', name: 'AFFIDAVIT FOR COLLECTION-INTESTATE' },
        { id: 'AFCT', name: 'AFFIDAVIT FOR COLLECTION-TESTATE' },
        { id: 'AFDD', name: 'AFFIDAVIT OF COLL, DISB & DIST' },
        { id: 'CRED', name: 'AFFIDAVIT OF NOTICE TO CREDITORS' },
        { id: 'PARN', name: 'AFFIDAVIT OF PARENTAGE' },
        { id: 'PUBL', name: 'AFFIDAVIT OF PUBLICATION' },
        { id: 'ALAF', name: 'ALIENATION OF AFFECTION' },
        { id: 'ALIM', name: 'ALIMONY' },
        { id: 'AMND', name: 'AMEND' },
        { id: 'ANCL', name: 'ANCILLARY ADMINISTRATION' },
        { id: '506A', name: 'ANNUAL ACCOUNT' },
        { id: 'ANUL', name: 'ANNULMENT' },
        { id: 'AAHR', name: 'APPEAL FOR ADMIN HEARING' },
        { id: 'APCS', name: 'APPOINTING COMMISSIONERS' },
        { id: 'AGAL', name: 'APPOINTING GUARDIAN AD LITEM' },
        { id: 'APRC', name: 'APPOINTMENT OF RECEIVER' },
        { id: 'AAWD', name: 'ARBITRATION AWARD FILED' },
        { id: 'ARBF', name: 'ARBITRATION FEE' },
        { id: 'ATDN', name: 'ARBITRATION TRIAL DE NOVO' },
        { id: 'ARAS', name: 'ASSERT RIGHT TO ACCESS' },
        { id: 'ASOT', name: 'ASSIGNMENT OF TITLE' },
        { id: 'ATTC', name: 'ATTACHMENT' },
        { id: 'JATF', name: 'ATTORNEY FEE - INDIGENT' },
        { id: 'ATFE', name: 'ATTORNEY FEES' },
        { id: 'ACCJ', name: 'AUTHORIZATION-CANC/CREDIT JDGMNT' },
        { id: 'AUTS', name: 'AUTHORIZATION TO SELL' },
        { id: 'BPAA', name: 'BAIL POWER OF APPOINTMENT/ATTORNEY' },
        { id: 'BANK', name: 'BANKRUPTCY DOCUMENTS' },
        { id: 'MBNK', name: 'BANKS AND MISC PAPERS OF' },
        { id: 'FILM', name: 'BATCH MICROFILM NUMBERS' },
        { id: 'BDFR', name: 'BOND FORFEITURE' },
        { id: 'BOND', name: 'BONDS - ALL' },
        { id: 'BLRR', name: 'BONDSMAN LICENSE (PRE-JUNE 2002)' },
        { id: 'BMBR', name: 'BONDSMAN MONTHLY BONDING REPORT' },
        { id: 'BNDL', name: 'BONDSMAN\'S LICENSE' },
        { id: 'BNDR', name: 'BOUNDARY SETTLEMENT' },
        { id: 'BULK', name: 'BULK SALE' },
        { id: 'CAMP', name: 'CAMPAIGN RECORDS/ELECT RTN ABSTR' },
        { id: 'CART', name: 'CARTWAY' },
        { id: 'CAVT', name: 'CAVEAT' },
        { id: 'CNBD', name: 'CERTIFICATE OF NEED BOND' },
        { id: 'CHVN', name: 'CHANGE OF VENUE' },
        { id: 'CSUP', name: 'CHILD SUPPORT' },
        { id: 'CSPL', name: 'CHILD SUPPORT LIEN' },
        { id: 'CITY', name: 'CITY GOVERNMENT/AGENCY DOCUMENTS' },
        { id: 'CVLM', name: 'CIVIL MISCELLANEOUS' },
        { id: 'CLMD', name: 'CLAIM AND DELIVERY' },
        { id: 'CDEX', name: 'CLAIM/DESIGNATE EXEMPT PROPERTY' },
        { id: 'CLOL', name: 'CLAIM OF LIEN' },
        { id: 'STAT', name: 'CLOSED STATISTICALLY' },
        { id: 'ACCT', name: 'COLLECTION ON ACCOUNT' },
        { id: 'COLL', name: 'COLLECTOR' },
        { id: 'CMPL', name: 'COMPEL' },
        { id: 'CNDM', name: 'CONDEMNATION' },
        { id: 'CNFR', name: 'CONFIRMATION' },
        { id: 'CNSL', name: 'CONSOLIDATION' },
        { id: 'CNTP', name: 'CONTEMPT' },
        { id: 'CNTN', name: 'CONTINUE' },
        { id: 'CNTR', name: 'CONTRACT' },
        { id: 'CSTA', name: 'COSTS - APPELLATE DIVISION' },
        { id: 'COST', name: 'COURT COSTS' },
        { id: 'CRMM', name: 'CRIMINAL MISCELLANEOUS' },
        { id: 'CUST', name: 'CUSTODY' },
        { id: 'SLPS', name: 'DECEDENT ESTATE SELL PERSONAL PROPERTY' },
        { id: 'DECJ', name: 'DECLARATORY JUDGMENT' },
        { id: 'DEFJ', name: 'DEFAULT JUDGMENT' },
        { id: 'DIFJ', name: 'DEFICIENCY JUDGMENT' },
        { id: 'DEPO', name: 'DEPOSITION' },
        { id: 'DSMD', name: 'DESIGNATE A MEDIATOR' },
        { id: 'DOSF', name: 'DETERMINE OWNER OF SURPLUS FUNDS' },
        { id: 'DISC', name: 'DISCONTINUANCE' },
        { id: 'DSCH', name: 'DISCOVERY SCHEDULING ORDER' },
        { id: 'DISM', name: 'DISMISS (INVOLUNTARY)' },
        { id: 'DISS', name: 'DISSENT FROM WILL' },
        { id: 'DIVR', name: 'DIVORCE' },
        { id: 'DIVB', name: 'DIVORCE FROM BED AND BOARD' },
        { id: 'DOME', name: 'DOMESTIC VIOLENCE' },
        { id: 'DVCS', name: 'DOMESTIC VIOLENCE TEMP CHILD SUPPORT' },
        { id: 'DVTC', name: 'DOMESTIC VIOLENCE TEMPORARY CUSTODY' },
        { id: 'DRDS', name: 'DRAINAGE DISTRICT - ESTABLISHMENT' },
        { id: 'DRNG', name: 'DRAINAGE - INDIVIDUAL/CORPORATION' },
        { id: 'ELSH', name: 'ELECTIVE SHARE' },
        { id: 'EMAN', name: 'EMANCIPATION' },
        { id: 'ESCL', name: 'EMPLOYMENT SECURITY COMM LIEN' },
        { id: 'EODF', name: 'ENTRY OF DEFAULT' },
        { id: 'EDFA', name: 'EQUITABLE DISTRIB FINANCIAL AFFIDAVIT' },
        { id: 'EQUD', name: 'EQUITABLE DISTRIBUTION' },
        { id: 'GUEI', name: 'ESTATE GUARDIANSHIP- INCOMPETENT' },
        { id: 'GUEM', name: 'ESTATE GUARDIANSHIP- MINOR' },
        { id: 'ETCL', name: 'ESTATE TAX CLOSING LETTER (IRS)' },
        { id: 'EXPR', name: 'EX PARTE RESTRAINING' },
        { id: 'EXAD', name: 'EXEMPLIFIED/CERTIFIED ADMINISTRATION' },
        { id: 'EXAR', name: 'EXEMPT FROM ARBITRATION' },
        { id: 'EXCV', name: 'EXEMPT FROM CUST/VISIT MEDIATION' },
        { id: 'EXMD', name: 'EXEMPT/WAIVE MEDIATION' },
        { id: 'EXTM', name: 'EXTENSION OF TIME' },
        { id: 'FSAG', name: 'FAMILY SETTLEMENT AGREEMENT' },
        { id: 'FEDG', name: 'FEDERAL GOVERNMENT/AGENCY DOC' },
        { id: 'IRSL', name: 'FEDERAL TAX LIEN' },
        { id: '506F', name: 'FINAL ACCOUNT' },
        { id: 'FAFR', name: 'FINAL ACCOUNT OR FINAL REPORT' },
        { id: 'FOAD', name: 'FINAL ORDER OF ADOPTION' },
        { id: 'FAOF', name: 'FINDINGS AND ORDER OF FORECLOSURE' },
        { id: 'FCRE', name: 'FINES, COSTS, RESTITUTION' },
        { id: 'FORE', name: 'FORECLOSURE' },
        { id: 'IVST', name: 'FUNDS INVEST MINOR/INCOMPETENT' },
        { id: 'GUIN', name: 'GENERAL GUARDIANSHIP-INCOMPETENT' },
        { id: 'GUMI', name: 'GENERAL GUARDIANSHIP-MINOR' },
        { id: 'GETS', name: 'GENETIC TESTING' },
        { id: 'GUPE', name: 'GUARDIANSHIP OF THE PERSON' },
        { id: 'HAND', name: 'HAND GUN PERMITS DENIED/APPROVED' },
        { id: 'HOTV', name: 'HEARING ON TOWED VEHICLES' },
        { id: 'HRCJ', name: 'HUMAN RELATIONS COMMISSION JUDGMENT' },
        { id: 'ILIM', name: 'IN LIMINE' },
        { id: 'INTC', name: 'IN THE CAUSE' },
        { id: 'INCM', name: 'INCOMPETENCY' },
        { id: 'ISAG', name: 'INCORP SEPARATION AGREEMENT' },
        { id: 'INBN', name: 'INCREASE BOND' },
        { id: 'INDM', name: 'INDEMNIFICATION' },
        { id: 'INCJ', name: 'INDUSTRIAL COMMISSION JUDGMENT' },
        { id: 'ITAX', name: 'INHERITANCE ESTATE TAX CERT (NC DOR)' },
        { id: 'INJU', name: 'INJUNCTION' },
        { id: 'HSPT', name: 'INSTITUTIONAL LIEN(HOSPITALS)' },
        { id: 'TORT', name: 'INTENTIONAL TORTS' },
        { id: 'ISWT', name: 'INTER-STATE WITNESS TESTIMONY' },
        { id: 'INDS', name: 'INTERIM DISTRIBUTION' },
        { id: 'INGU', name: 'INTERIM GUARDIANSHIP' },
        { id: 'INTR', name: 'INTERVENE' },
        { id: '505I', name: 'INVENTORY' },
        { id: '510I', name: 'INVENTORY FOR GUARDIANSHIP ESTATE' },
        { id: '511I', name: 'INVENTORY FOR TRUST UNDER WILL' },
        { id: 'JOIN', name: 'JOIN' },
        { id: 'ADMN', name: 'JUDGE ADMINISTRATIVE ORDER' },
        { id: 'JOPL', name: 'JUDGMENT ON PLEADING' },
        { id: 'JSOA', name: 'JUDICIAL SETTLEMENT OF APPEAL' },
        { id: 'JURF', name: 'JURY FINE' },
        { id: 'JRVW', name: 'JURY VIEW' },
        { id: 'TORR', name: 'LAND REGISTRATION TORRENS ACT' },
        { id: 'LGMT', name: 'LEGITIMATION' },
        { id: 'LOAD', name: 'LETTERS OF ADMINISTRATION' },
        { id: 'LIEN', name: 'LIEN' },
        { id: 'LDEP', name: 'LIMIT DEPOSITION' },
        { id: 'PLDP', name: 'LIMITED DRIVING PRIVILEGE' },
        { id: 'LISP', name: 'LIS PENDENS' },
        { id: '910M', name: 'LIST OF PHASE TWO DISTRIBUTEES' },
        { id: 'LOCK', name: 'LOCK BOX INVENTORY' },
        { id: 'MEDC', name: 'MEDICAL COVERAGE' },
        { id: 'MDLN', name: 'MEDICAL LIEN' },
        { id: 'MDML', name: 'MEDICAL MALPRACTICE' },
        { id: 'DFND', name: 'MINOR ESTATE - DISBURSE FUNDS' },
        { id: 'MIES', name: 'MINOR/INCOM ESTATE SELL/LEASE/MORTGAGE' },
        { id: 'MSTL', name: 'MINOR SETTLEMENT' },
        { id: 'MISC', name: 'MISCELLANEOUS' },
        { id: 'MALI', name: 'MODIFICATION OF ALIMONY' },
        { id: 'MCUS', name: 'MODIFICATION OF CUSTODY' },
        { id: 'MSUP', name: 'MODIFICATION OF SUPPORT' },
        { id: 'MVIS', name: 'MODIFICATION OF VISITATION' },
        { id: 'MNYO', name: 'MONEY OWED' },
        { id: 'MDST', name: 'MORE DEFINITE STATEMENT(RULE 12)' },
        { id: 'MVLN', name: 'MOTOR VEHICLE LIEN GS 44A' },
        { id: 'MVNG', name: 'MOTOR VEHICLE NEGLIGENCE' },
        { id: 'NAME', name: 'NAME CHANGE' },
        { id: 'CLSR', name: 'NC CERTIFICATE OF TAX LIABILITY' },
        { id: 'DHCA', name: 'NC DHHS BREATH/BLOOD/PREV MAIN' },
        { id: 'NEGO', name: 'NEGLIGENCE - OTHER' },
        { id: 'NTRL', name: 'NEW TRIAL' },
        { id: 'NVRT', name: 'NON-VRA/NON-VICTIM RESTITUTION' },
        { id: 'NOCT', name: 'NOTICE OF CONTRACT' },
        { id: 'ESCT', name: 'NOTICE OF ESCHEAT PROPERTY' },
        { id: 'NLEN', name: 'NOTICE OF LIEN - CONTRACT' },
        { id: 'OATH', name: 'OATHS OF OFFICE' },
        { id: 'OEXC', name: 'OBJECTION TO EXEMPTIONS CLAIMED' },
        { id: 'OFOJ', name: 'OFFER OF JUDGMENT' },
        { id: 'ORDD', name: 'ORDER OF DISCIPLINE/DISABILITY' },
        { id: 'ORDR', name: 'ORDER - SALE OR DESTRUCT OF PROP' },
        { id: 'OARB', name: 'ORDER TO ARBITRATION' },
        { id: 'OTCM', name: 'ORDER TO CUSTODY MEDIATION' },
        { id: 'OMSC', name: 'ORDER TO MEDIATED SETTLEMENT' },
        { id: 'OOSP', name: 'ORDER TO THE OTHER SETTLEMENT PROCEDURE' },
        { id: 'OSHA', name: 'OSHA JUDGMENT' },
        { id: 'OTHR', name: 'OTHER' },
        { id: 'OWEL', name: 'OWELTY' },
        { id: 'PART', name: 'PARTITION' },
        { id: 'PATR', name: 'PATERNITY' },
        { id: 'PYCL', name: 'PAYMENTS TO CLERK 28A-25.6' },
        { id: 'PERS', name: 'PEREMPTORY SETTING' },
        { id: 'PCNC', name: 'PERMANENT CIVIL NO-CONTACT ORDER' },
        { id: 'PROR', name: 'PERMANENT RESTRAINING ORDER' },
        { id: 'PESE', name: 'PETITION TO SELL' },
        { id: 'POSS', name: 'POSSESSION' },
        { id: 'POPP', name: 'POSSESSION OF PERSONAL PROPERTY' },
        { id: 'PSSU', name: 'POST SEPARATION SUPPORT' },
        { id: 'POAT', name: 'POWER OF ATTORNEY' },
        { id: 'PREL', name: 'PRELIMINARY INJUNCTION' },
        { id: 'FARM', name: 'PRELITIGATION FARM NUISANCE MEDIATION' },
        { id: 'PRTO', name: 'PRETRIAL ORDER' },
        { id: 'PROB', name: 'PROBATE- LETTERS TESTAMENTARY, ADMIN CTA' },
        { id: 'PEDA', name: 'PROCEEDING EXAM TO DISCOVER ASSETS' },
        { id: 'TDHE', name: 'PROCEEDING TO DETMINE UNKNOWN HEIRS' },
        { id: 'PROD', name: 'PRODUCT LIABILITY' },
        { id: 'PRBD', name: 'PROSECUTION OF BOND' },
        { id: 'PRSE', name: 'PROTECTIVE SERVICES - ADULT' },
        { id: 'PSYC', name: 'PSYCHOLOGICAL EVALUATION' },
        { id: 'PUAF', name: 'PUBLISHERS AFFIDAVIT' },
        { id: 'PDAM', name: 'PUNITIVE DAMAGES' },
        { id: 'QDRO', name: 'QUALIFIED DOMESTIC RELATIONS ORDER' },
        { id: 'QUSH', name: 'QUASH' },
        { id: 'RLPR', name: 'REAL PROPERTY / TITLE' },
        { id: 'REAG', name: 'RECEIPT / AGREEMENT' },
        { id: 'DEST', name: 'RECORD DESTRUCTION REQUESTS' },
        { id: 'RPBJ', name: 'REFUND OF PAYMENT MADE BEFORE JUDGMENT' },
        { id: 'FORJ', name: 'REGISTRATION OF FOREIGN JDGMNT' },
        { id: 'RPPA', name: 'REIMBURSE PAST PUBLIC ASSISTANCE' },
        { id: 'REIN', name: 'REINSTATEMENT FROM BANKRUPCTCY' },
        { id: 'RODI', name: 'REINSTATEMENT FROM ORDER OF DISCIPLINE' },
        { id: 'RSEX', name: 'RELEASE FROM STAY OF EXECUTION' },
        { id: 'ROPM', name: 'RELIEF-OBLIGATION PAY MEDIAT FEE' },
        { id: 'RMND', name: 'REMAND' },
        { id: 'RFAJ', name: 'REMIT FORFEITURE' },
        { id: 'RECO', name: 'REMOVAL OF COURT OFFICIAL' },
        { id: 'RSOT', name: 'REMOVAL/SUBSTITUTION OF TRUSTEE' },
        { id: 'RPRO', name: 'RENEW PERMANENT RESTRAINING ORDER' },
        { id: 'RPCN', name: 'RENEWAL OF PERMANENT CIVIL NO-CONTACT' },
        { id: 'RRTQ', name: 'RENOUNCE RIGHT TO QUALIFY' },
        { id: 'RETQ', name: 'RENOUNCE TO QUALIFY' },
        { id: 'RNIE', name: 'RENUNCIATION OF INTEREST - ESTATE' },
        { id: 'RNUN', name: 'RENUNCIATION OF INTEREST-NO ESTATE' },
        { id: 'RNTT', name: 'RENUNCIATION OF TESTAMENTARY TRUSTEE' },
        { id: 'REOP', name: 'REOPEN' },
        { id: 'REOC', name: 'REPORT OF COMMISSIONERS' },
        { id: 'RPFS', name: 'REPORT OF FORECLOSURE SALE' },
        { id: 'REOS', name: 'REPORT OF SALE' },
        { id: 'RPAD', name: 'RESIDENT PROCESS AGENT DESIGNATION' },
        { id: 'RRFD', name: 'RESIGN / REMOVE FIDUCIARY' },
        { id: 'RSNT', name: 'RESIGNATION OF TRUSTEE' },
        { id: 'ROCP', name: 'RESTORATION OF CITIZENSHIP' },
        { id: 'RFAR', name: 'RESTORATION OF FIREARM RIGHTS' },
        { id: 'RTCO', name: 'RESTORATION TO COMPETENCY' },
        { id: 'RESU', name: 'RESUMPTION OF FORMER NAME' },
        { id: 'RDCC', name: 'RETALIATORY DISCHARGE' },
        { id: 'MDLA', name: 'RULE 12 MOTION IN LIEU OF ANSWER' },
        { id: 'SSPR', name: 'SALE OF SURPLUS PROPERTY' },
        { id: 'SANC', name: 'SANCTIONS' },
        { id: 'SRCH', name: 'SEARCH WARRANTS - CIVIL AND CRIM' },
        { id: 'SMAP', name: 'SELECTION OF MEDIATOR BY AGREE' },
        { id: 'SADJ', name: 'SET ASIDE DEFAULT JUDGMENT' },
        { id: 'SADS', name: 'SET ASIDE DISPOSITION' },
        { id: 'SAED', name: 'SET ASIDE ENTRY OF DEFAULT' },
        { id: 'SFSJ', name: 'SET ASIDE FORECLOSURE SALE' },
        { id: 'SFBJ', name: 'SET ASIDE FORFEITURE' },
        { id: 'SAJD', name: 'SET ASIDE JUDGMENT' },
        { id: 'SAJV', name: 'SET ASIDE JURY VERDICT' },
        { id: 'SAEP', name: 'SET ASIDE ORDER EXEMPTING PROPERTY' },
        { id: 'SICL', name: 'SEVER ISSUES OR CLAIMS' },
        { id: 'SHOW', name: 'SHOW CAUSE' },
        { id: 'FACS', name: 'SIGNATURE FACSIMILE' },
        { id: 'ADMP', name: 'SPECIAL ADMISSION PRACTICE IN NC' },
        { id: 'SPPR', name: 'SPECIFIC PERFORMANCE' },
        { id: 'SGUG', name: 'STANDBY GENERAL GUARDIANSHIP -MINOR' },
        { id: 'SGUP', name: 'STANDBY GUARDIANSHIP OF PERSON -MINOR' },
        { id: 'STTG', name: 'STATE GOVERNMENT/AGENCY DOC' },
        { id: 'STOA', name: 'STATEMENT OF ACCOUNT' },
        { id: 'STEX', name: 'STAY OF EXECUTION' },
        { id: 'SEXD', name: 'STAY OF EXECUTION DISSOLVED' },
        { id: 'STRL', name: 'STERILIZATION' },
        { id: 'STRK', name: 'STRIKE' },
        { id: 'SUMA', name: 'SUMMARY ADMINISTRATION' },
        { id: 'SUME', name: 'SUMMARY EJECTMENT' },
        { id: 'SUMJ', name: 'SUMMARY JUDGMENT' },
        { id: 'SUPR', name: 'SUPPLEMENTAL PROCEEDINGS' },
        { id: 'SSCA', name: 'SURVIVING SPOUSE/CHILDS ALLOWANCE' },
        { id: 'SUSL', name: 'SUSPEND/REVOKE LICENSE (REAL ESTATE)' },
        { id: 'SUBL', name: 'SUSPENSION OF STATE BAR LICENSE' },
        { id: 'TAXD', name: 'TAX DELINQUENCY' },
        { id: 'TEGU', name: 'TEMPORARY GUARDIANSHIP - MINOR' },
        { id: 'TROR', name: 'TEMPORARY RESTRAINING ORDER' },
        { id: 'TOBL', name: 'TERMINATION OF BONDSMAN LICENSE' },
        { id: 'TERM', name: 'TERMINATION OF OATH' },
        { id: 'TSMV', name: 'TOWING/STORAGE OF MOTOR VEHICLE' },
        { id: 'TRAN', name: 'TRANSCRIPT OF JUDGMENT' },
        { id: 'T000', name: 'TRANSCRIPT TO ALAMANCE' },
        { id: 'T010', name: 'TRANSCRIPT TO ALEXANDER' },
        { id: 'T020', name: 'TRANSCRIPT TO ALLEGHANY' },
        { id: 'T030', name: 'TRANSCRIPT TO ANSON' },
        { id: 'T040', name: 'TRANSCRIPT TO ASHE' },
        { id: 'T050', name: 'TRANSCRIPT TO AVERY' },
        { id: 'T060', name: 'TRANSCRIPT TO BEAUFORT' },
        { id: 'T070', name: 'TRANSCRIPT TO BERTIE' },
        { id: 'T080', name: 'TRANSCRIPT TO BLADEN' },
        { id: 'T090', name: 'TRANSCRIPT TO BRUNSWICK' },
        { id: 'T100', name: 'TRANSCRIPT TO BUNCOMBE' },
        { id: 'T110', name: 'TRANSCRIPT TO BURKE' },
        { id: 'T120', name: 'TRANSCRIPT TO CABARRUS' },
        { id: 'T130', name: 'TRANSCRIPT TO CALDWELL' },
        { id: 'T140', name: 'TRANSCRIPT TO CAMDEN' },
        { id: 'T150', name: 'TRANSCRIPT TO CARTERET' },
        { id: 'T160', name: 'TRANSCRIPT TO CASWELL' },
        { id: 'T170', name: 'TRANSCRIPT TO CATAWBA' },
        { id: 'T180', name: 'TRANSCRIPT TO CHATHAM' },
        { id: 'T190', name: 'TRANSCRIPT TO CHEROKEE' },
        { id: 'T200', name: 'TRANSCRIPT TO CHOWAN' },
        { id: 'T210', name: 'TRANSCRIPT TO CLAY' },
        { id: 'T220', name: 'TRANSCRIPT TO CLEVELAND' },
        { id: 'T230', name: 'TRANSCRIPT TO COLUMBUS' },
        { id: 'T240', name: 'TRANSCRIPT TO CRAVEN' },
        { id: 'T250', name: 'TRANSCRIPT TO CUMBERLAND' },
        { id: 'T260', name: 'TRANSCRIPT TO CURRITUCK' },
        { id: 'T270', name: 'TRANSCRIPT TO DARE' },
        { id: 'T280', name: 'TRANSCRIPT TO DAVIDSON' },
        { id: 'T290', name: 'TRANSCRIPT TO DAVIE' },
        { id: 'T300', name: 'TRANSCRIPT TO DUPLIN' },
        { id: 'T310', name: 'TRANSCRIPT TO DURHAM' },
        { id: 'T320', name: 'TRANSCRIPT TO EDGECOMBE' },
        { id: 'T330', name: 'TRANSCRIPT TO FORSYTH' },
        { id: 'T340', name: 'TRANSCRIPT TO FRANKLIN' },
        { id: 'T350', name: 'TRANSCRIPT TO GASTON' },
        { id: 'T360', name: 'TRANSCRIPT TO GATES' },
        { id: 'T370', name: 'TRANSCRIPT TO GRAHAM' },
        { id: 'T380', name: 'TRANSCRIPT TO GRANVILLE' },
        { id: 'T390', name: 'TRANSCRIPT TO GREENE' },
        { id: 'T400', name: 'TRANSCRIPT TO GUILFORD' },
        { id: 'T410', name: 'TRANSCRIPT TO HALIFAX' },
        { id: 'T420', name: 'TRANSCRIPT TO HARNETT' },
        { id: 'T430', name: 'TRANSCRIPT TO HAYWOOD' },
        { id: 'T440', name: 'TRANSCRIPT TO HENDERSON' },
        { id: 'T450', name: 'TRANSCRIPT TO HERTFORD' },
        { id: 'T460', name: 'TRANSCRIPT TO HOKE' },
        { id: 'T470', name: 'TRANSCRIPT TO HYDE' },
        { id: 'T480', name: 'TRANSCRIPT TO IREDELL' },
        { id: 'T490', name: 'TRANSCRIPT TO JACKSON' },
        { id: 'T500', name: 'TRANSCRIPT TO JOHNSTON' },
        { id: 'T510', name: 'TRANSCRIPT TO JONES' },
        { id: 'T520', name: 'TRANSCRIPT TO LEE' },
        { id: 'T530', name: 'TRANSCRIPT TO LENOIR' },
        { id: 'T540', name: 'TRANSCRIPT TO LINCOLN' },
        { id: 'T550', name: 'TRANSCRIPT TO MACON' },
        { id: 'T560', name: 'TRANSCRIPT TO MADISON' },
        { id: 'T570', name: 'TRANSCRIPT TO MARTIN' },
        { id: 'T580', name: 'TRANSCRIPT TO MCDOWELL' },
        { id: 'T590', name: 'TRANSCRIPT TO MECKLENBURG' },
        { id: 'T600', name: 'TRANSCRIPT TO MITCHELL' },
        { id: 'T610', name: 'TRANSCRIPT TO MONTGOMERY' },
        { id: 'T620', name: 'TRANSCRIPT TO MOORE' },
        { id: 'T630', name: 'TRANSCRIPT TO NASH' },
        { id: 'T640', name: 'TRANSCRIPT TO NEW HANOVER' },
        { id: 'T650', name: 'TRANSCRIPT TO NORTHAMPTON' },
        { id: 'T660', name: 'TRANSCRIPT TO ONSLOW' },
        { id: 'T670', name: 'TRANSCRIPT TO ORANGE' },
        { id: 'T680', name: 'TRANSCRIPT TO PAMLICO' },
        { id: 'T690', name: 'TRANSCRIPT TO PASQUOTANK' },
        { id: 'T700', name: 'TRANSCRIPT TO PENDER' },
        { id: 'T710', name: 'TRANSCRIPT TO PERQUIMANS' },
        { id: 'T720', name: 'TRANSCRIPT TO PERSON' },
        { id: 'T730', name: 'TRANSCRIPT TO PITT' },
        { id: 'T740', name: 'TRANSCRIPT TO POLK' },
        { id: 'T750', name: 'TRANSCRIPT TO RANDOLPH' },
        { id: 'T760', name: 'TRANSCRIPT TO RICHMOND' },
        { id: 'T770', name: 'TRANSCRIPT TO ROBESON' },
        { id: 'T780', name: 'TRANSCRIPT TO ROCKINGHAM' },
        { id: 'T790', name: 'TRANSCRIPT TO ROWAN' },
        { id: 'T800', name: 'TRANSCRIPT TO RUTHERFORD' },
        { id: 'T810', name: 'TRANSCRIPT TO SAMPSON' },
        { id: 'T820', name: 'TRANSCRIPT TO SCOTLAND' },
        { id: 'T830', name: 'TRANSCRIPT TO STANLY' },
        { id: 'T840', name: 'TRANSCRIPT TO STOKES' },
        { id: 'T850', name: 'TRANSCRIPT TO SURRY' },
        { id: 'T860', name: 'TRANSCRIPT TO SWAIN' },
        { id: 'T870', name: 'TRANSCRIPT TO TRANSYLVANIA' },
        { id: 'T880', name: 'TRANSCRIPT TO TYRRELL' },
        { id: 'T890', name: 'TRANSCRIPT TO UNION' },
        { id: 'T900', name: 'TRANSCRIPT TO VANCE' },
        { id: 'T910', name: 'TRANSCRIPT TO WAKE' },
        { id: 'T920', name: 'TRANSCRIPT TO WARREN' },
        { id: 'T930', name: 'TRANSCRIPT TO WASHINGTON' },
        { id: 'T940', name: 'TRANSCRIPT TO WATAUGA' },
        { id: 'T950', name: 'TRANSCRIPT TO WAYNE' },
        { id: 'T960', name: 'TRANSCRIPT TO WILKES' },
        { id: 'T970', name: 'TRANSCRIPT TO WILSON' },
        { id: 'T980', name: 'TRANSCRIPT TO YADKIN' },
        { id: 'T990', name: 'TRANSCRIPT TO YANCEY' },
        { id: 'TRFR', name: 'TRANSFER' },
        { id: 'TOTL', name: 'TRANSFER OF TITLE' },
        { id: 'TRST', name: 'TRUST' },
        { id: 'TCEM', name: 'TRUST - CEMETERY' },
        { id: 'TRNQ', name: 'TRUST U/WILL QUAL REQ, NO ACCOUNTINGS' },
        { id: 'TRUW', name: 'TRUST UNDER WILL' },
        { id: 'UNMA', name: 'UNDERAGE MARRIAGE' },
        { id: 'UNTP', name: 'UNFAIR TRADE PRACTICE' },
        { id: 'CNAB', name: 'UNIFORM ARBITRATION ACT' },
        { id: 'UDHP', name: 'UNLAWFUL DISCRIMINATORY HOUSING PRACTICE' },
        { id: 'UPST', name: 'UPSET BID FILED' },
        { id: 'USJU', name: 'US DISTRICT COURT JUDGMENT' },
        { id: 'VCMD', name: 'VACATE/MODIFY JUDGMENT OR ORDER' },
        { id: 'VRST', name: 'VICTIMS RESTITUTION' },
        { id: 'VIST', name: 'VISITATION' },
        { id: 'VMED', name: 'VOLUNTARY MEDIATION' },
        { id: 'WAIV', name: 'WAIVER OF BOND' },
        { id: 'WLOS', name: 'WILL OUT OF STATE' },
        { id: 'WLNP', name: 'WILL RECORDED -NOT PROBATED' },
        { id: 'WLPR', name: 'WILL RECORDED -PROBATED' },
        { id: 'WDCN', name: 'WITHDRAW AS COUNSEL' },
        { id: 'CERT', name: 'WRIT OF CERTIORARI' },
        { id: 'WRDE', name: 'WRONGFUL DEATH' },
        { id: 'WRDI', name: 'WRONGFUL DISCHARGE' },
        { id: 'YEAL', name: 'YEARS ALLOWANCE' },
        { id: '9999', name: 'NO ISSUE IS ASSOCIATED WITH PARTY' }
      ];
    }



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/civil/civil-search-constants.ts